export function matchFilterValues(selected: string[], value: string | null | undefined): boolean {
  if (selected.length === 0) return true
  const normalized = (value ?? '').toLowerCase()
  return selected.some((item) => item.toLowerCase() === normalized)
}

export function filterBarValue(selected: string[]): string {
  if (selected.length === 0) return ''
  if (selected.length === 1) return selected[0] ?? ''
  return '__multi__'
}

export function filterBarLabel(selected: string[], emptyLabel: string, multiLabel: string): string {
  if (selected.length === 0) return emptyLabel
  if (selected.length === 1) return selected[0] ?? emptyLabel
  return multiLabel.replace('{count}', String(selected.length))
}
